import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://spb-8vb5nhr43wo8yt73.supabase.opentrust.net'
const supabaseKey = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiYW5vbiIsInJlZiI6InNwYi04dmI1bmhyNDN3bzh5dDczIiwiaXNzIjoic3VwYWJhc2UiLCJpYXQiOjE3NzM3NzE4ODgsImV4cCI6MjA4OTM0Nzg4OH0.6P3g6CWOqwg0nZead9La_20uOe_3rXKLj78y7L0p5bU'

export const supabase = createClient(supabaseUrl, supabaseKey)